import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {FormGroup, FormBuilder, AbstractControl} from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsPlannerService} from "./settings-planner.service";
import {DtoAppointmentKind} from "./models/DtoAppointmentKind";
import {Observable} from "rxjs/Observable";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoAppointmentKindBaseItems} from "./models/DtoAppointmentKindBaseItems";

@Component({
    selector: 'appointmentkind',
    template: require('./appointmentkind.component.html'),
    styles: [require('./appointmentkind.component.css')]
})
@AutoUnsubscribe()

export class AppointmentkindComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoAppointmentKind;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    baseItems: DtoAppointmentKindBaseItems;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsPlannerService,
                private ss: SharedService) { }

    ngOnInit() {
        this.form = this.fb.group({
            description: [null, [SharedValidators.customRequired]],
            onlineBookingDescription: null,
            duration: [null,[SharedValidators.customRequired, this.validateMinimalDuration.bind(this)]],
            extension: null,
            showInAgenda: null,
            showInOnlineAgenda: null,
            index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
            recActive: null,
            appointmentLabelId: [null,[SharedValidators.customRequired]],
            genderId: null,
            maxAtOnce: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getAppointmentKindById(this.id)
                .subscribe(response => {
                    this.getBaseItems();
                    this.dtoObject = response;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.ds.getAppoinmentKindNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        recActive: true,
                        index: res,
                        genderId: 0,
                        extension: 0,
                        maxAtOnce: 0,
                        showInAgenda: true,
                        showInOnlineAgenda: true,
                        appointmentKindCombinations: []
                    };
                    this.getBaseItems();
                    if (this.copyFromId > 0) {
                        this.ds.getAppointmentKindById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.showInAgenda = response.showInAgenda;
                                this.dtoObject.showInOnlineAgenda = response.showInOnlineAgenda;
                                this.dtoObject.duration = response.duration;
                                this.dtoObject.extension = response.extension;
                                this.dtoObject.appointmentLabelId = response.appointmentLabelId;

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getAppointmentKindBaseItems(false).subscribe(response => {
            this.baseItems = response;
        });
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkAppoinmentKindIndexAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateMinimalDuration(control: AbstractControl) {
        if (control.dirty && control.value != null) {
            if (control.value < 5)
                return {durationToShort: true};
        }

        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveAppointmentKind(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/appointmentkind.component.ts